import React from 'react';
import { ComingSoonPage } from '@components/ui/pages';
import { Typography } from '@mui/material';
import { useEventTracking } from '@services/statsig';

import { useTracking } from '../../../context/TrackingContext';
import { EventType } from '../../../types/events';

/**
 * ReportsAnalyticsPage Component
 *
 * A "coming soon" page for the Reports and Analytics feature.
 * Displays information about the upcoming analytics feature
 * with a CTA for expressing interest.
 */
export const ReportsAnalyticsPage: React.FC = () => {
  const { analytics } = useEventTracking();
  const { trackEvent } = useTracking();

  const handleInterestedClick = () => {
    analytics.interestedClicked();
    trackEvent(EventType.EXPRESSED_INTEREST, {
      feature: 'reports_analytics',
    });
  };

  return (
    <ComingSoonPage
      title="Reports and analytics"
      showHeader={false}
      heroTitle="Reports and analytics"
      description={
        <Typography component="span" sx={{ fontStyle: 'italic' }}>
          Coming soon
        </Typography>
      }
      primaryAction={{
        label: "I'm Interested",
        onClick: handleInterestedClick,
      }}
    />
  );
};

